
function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}

      var $parcel$global = globalThis;
    var parcelRequire = $parcel$global["parcelRequired477"];
var parcelRegister = parcelRequire.register;
parcelRegister("3kPYw", function(module, exports) {
/**
 * @generated SignedSource<<eed62b01df3a15f929c3541959ed3dba>>
 * @relayHash 26162da9421b897123835870aa889a88
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID a3004a6a0ad1b804118c2ddd213ca62e54dddd52039fedc3d0b3477084c941b9
const $1d0c8a8dbf14d1c8$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "requestPageAccessInput"
        }
    ], v1 = [
        {
            "args": [
                {
                    "kind": "Variable",
                    "name": "requestPageAccessInput",
                    "variableName": "requestPageAccessInput"
                }
            ],
            "concreteType": "RequestPageAccessPayload",
            "kind": "LinkedField",
            "name": "requestPageAccess",
            "plural": false,
            "selections": [
                {
                    "kind": "ScalarField",
                    "name": "displayName"
                }
            ]
        }
    ];
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "name": "RestrictedPageRequestPageAccessMutation",
            "selections": v1 /*: any*/ ,
            "type": "Mutation"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "RestrictedPageRequestPageAccessMutation",
            "selections": v1 /*: any*/ 
        },
        "params": {
            "cacheID": "26162da9421b897123835870aa889a88",
            "id": "a3004a6a0ad1b804118c2ddd213ca62e54dddd52039fedc3d0b3477084c941b9",
            "metadata": {},
            "name": "RestrictedPageRequestPageAccessMutation",
            "operationKind": "mutation",
            "text": "mutation RestrictedPageRequestPageAccessMutation($requestPageAccessInput:RequestPageAccessInput!){requestPageAccess(requestPageAccessInput:$requestPageAccessInput){displayName}}"
        }
    };
}();
$1d0c8a8dbf14d1c8$var$node.hash = "bfa35553df246be210070fea4313ce8c";
var $1d0c8a8dbf14d1c8$export$2e2bcd8739ae039 = $1d0c8a8dbf14d1c8$var$node;



var $e5EnV = parcelRequire("e5EnV");


var $cozmU = parcelRequire("cozmU");


var $hekY6 = parcelRequire("hekY6");


var $kSwu1 = parcelRequire("kSwu1");


var $kNIYN = parcelRequire("kNIYN");


var $9DHhW = parcelRequire("9DHhW");


var $ad7Ou = parcelRequire("ad7Ou");


var $eKMV3 = parcelRequire("eKMV3");


var $57p4j = parcelRequire("57p4j");


var $iMnC5 = parcelRequire("iMnC5");


var $1l0kj = parcelRequire("1l0kj");


var $4aRua = parcelRequire("4aRua");


var $5ZtfK = parcelRequire("5ZtfK");


var $a33Aa = parcelRequire("a33Aa");


var $bQm3c = parcelRequire("bQm3c");


var $d9tcB = parcelRequire("d9tcB");


var $lLRfG = parcelRequire("lLRfG");


var $b3j2Y = parcelRequire("b3j2Y");


var $3IBnw = parcelRequire("3IBnw");


var $1uFM6 = parcelRequire("1uFM6");


var $4PPzL = parcelRequire("4PPzL");


var $7LI3Q = parcelRequire("7LI3Q");


var $irVI7 = parcelRequire("irVI7");


var $gfIPU = parcelRequire("gfIPU");

var $ln0hx = parcelRequire("ln0hx");

var $1eaCJ = parcelRequire("1eaCJ");

var $1kHsc = parcelRequire("1kHsc");


var $gqqjz = parcelRequire("gqqjz");


var $8dwdz = parcelRequire("8dwdz");


var $jlIaF = parcelRequire("jlIaF");


var $1NBp8 = parcelRequire("1NBp8");


var $auKqk = parcelRequire("auKqk");


var $ep3mz = parcelRequire("ep3mz");


var $7Sm4c = parcelRequire("7Sm4c");


var $3GP6F = parcelRequire("3GP6F");


var $cLo2u = parcelRequire("cLo2u");


var $dPJCf = parcelRequire("dPJCf");


var $dmDX7 = parcelRequire("dmDX7");


var $e4o8D = parcelRequire("e4o8D");


var $6mKj3 = parcelRequire("6mKj3");


var $jMyy4 = parcelRequire("jMyy4");


var $308Wd = parcelRequire("308Wd");


var $hXDOc = parcelRequire("hXDOc");


var $f3euL = parcelRequire("f3euL");

var $48f57c9738ecf456$exports = {};
$48f57c9738ecf456$exports = new URL("CantViewLight.81544b8c.svg", import.meta.url).toString();


var $86fd97c8a2c8e096$exports = {};
$86fd97c8a2c8e096$exports = new URL("CantViewDark.ef25ef94.svg", import.meta.url).toString();


var $a8b3eb31fb232cc3$exports = {};
$a8b3eb31fb232cc3$exports = new URL("CantEditLight.0ee7f232.svg", import.meta.url).toString();


var $4e899128cd11b947$exports = {};
$4e899128cd11b947$exports = new URL("CantEditDark.190a22b1.svg", import.meta.url).toString();



var $3NZlV = parcelRequire("3NZlV");


var $27iZh = parcelRequire("27iZh");

var $77ac9f10750cf0ea$exports = {};
$77ac9f10750cf0ea$exports = new URL("CantEditLightMohiti.5b4f6a82.svg", import.meta.url).toString();


var $c0ceb2a3446506d8$exports = {};
$c0ceb2a3446506d8$exports = new URL("CantEditDarkMohiti.11451777.svg", import.meta.url).toString();



var $c9iq1 = parcelRequire("c9iq1");


var $fxpoI = parcelRequire("fxpoI");


var $9at9H = parcelRequire("9at9H");

const $cc1cd145e3df0c55$var$RestrictedPageWithCanViewQueryGraphQL = (0, $e5EnV.default);
const $cc1cd145e3df0c55$var$RestrictedPageRequestPageAccessMutationGraphQL = (0, $1d0c8a8dbf14d1c8$export$2e2bcd8739ae039);
const $cc1cd145e3df0c55$var$SUCCESS_FLAG_ID = 'reqestAccessSuccess';
const $cc1cd145e3df0c55$var$ButtonContainer = /*#__PURE__*/ (0, $cozmU.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    const { align: align, isMobile: isMobile, ...__cmpldp } = __cmplp;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement(C, {
        ...__cmpldp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hekY6.default)([
            "_2mHwu82ADO _313842NHnM _3iDTPbQ4SZ",
            __cmplp.align === 'center' || __cmplp.isMobile ? "_37wbyuDIqT" : "_37wbyuecOK",
            __cmplp.className
        ])
    });
});
const $cc1cd145e3df0c55$var$styles = {
    buttonPlaceholder: "_2XsHFM2ADO _0jFU0VUofl _39xV02Uofl _3iDTPbQ4SZ _0hPCNLDIqT"
}; // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $cc1cd145e3df0c55$var$RequestConfirmationTextContainer = /*#__PURE__*/ (0, $cozmU.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hekY6.default)([
            "_0hPCNLDIqT _37wbyuDIqT _3iDTPbQ4SZ _0jFU0VUofl _2Zuz6Q2ADO _1Znuxb2ADO",
            __cmplp.className
        ])
    });
});
const $cc1cd145e3df0c55$var$CUSTOM_ATTRIBUTES = {
    inaccessiblePageType: 'RESTRICTED_PAGE'
};
const $cc1cd145e3df0c55$var$i18n = (0, $kSwu1.defineMessages)({
    requestSentTitle: {
        id: "no-permission.restricted.page.request.access.successful.title.2",
        defaultMessage: "Request sent"
    },
    reminderSentTitle: {
        id: "no-permission.restricted.page.request.access.reminder-sent.title",
        defaultMessage: "Reminder sent"
    },
    requestFailedTitle: {
        id: "no-permission.restricted.page.request.access.failed.title",
        defaultMessage: "Access request unsuccessful"
    },
    reminderFailedTitle: {
        id: "no-permission.restricted.page.request.access.reminder-failed.title",
        defaultMessage: "Reminder not sent"
    },
    requestFailedBody: {
        id: "no-permission.restricted.page.request.access.failed.message.2",
        defaultMessage: "We ran into a problem submitting your access request. Try again or contact your admin."
    },
    reminderFailedBody: {
        id: "no-permission.restricted.page.request.access.reminder-failed.message",
        defaultMessage: "We ran into a problem sending your reminder. Try again or contact your admin."
    }
});
const $cc1cd145e3df0c55$var$LICENSED_ACCESS_STATUSES = new Set([
    (0, $d9tcB.AccessStatus).LICENSED_ADMIN_ACCESS,
    (0, $d9tcB.AccessStatus).LICENSED_USE_ACCESS,
    (0, $d9tcB.AccessStatus).EXTERNAL_COLLABORATOR_ACCESS
]);
const $cc1cd145e3df0c55$var$restrictedContentIllustration = {
    light: (0, (/*@__PURE__*/$parcel$interopDefault($48f57c9738ecf456$exports))),
    dark: (0, (/*@__PURE__*/$parcel$interopDefault($86fd97c8a2c8e096$exports)))
};
const $cc1cd145e3df0c55$var$restrictedContentMohitiIllustration = {
    light: (0, (/*@__PURE__*/$parcel$interopDefault($3NZlV))),
    dark: (0, (/*@__PURE__*/$parcel$interopDefault($27iZh)))
};
const $cc1cd145e3df0c55$var$requestEditAccessIllustration = {
    light: (0, (/*@__PURE__*/$parcel$interopDefault($a8b3eb31fb232cc3$exports))),
    dark: (0, (/*@__PURE__*/$parcel$interopDefault($4e899128cd11b947$exports)))
};
const $cc1cd145e3df0c55$var$requestEditAccessMohitiIllustration = {
    light: (0, (/*@__PURE__*/$parcel$interopDefault($77ac9f10750cf0ea$exports))),
    dark: (0, (/*@__PURE__*/$parcel$interopDefault($c0ceb2a3446506d8$exports)))
};
const $cc1cd145e3df0c55$var$RestrictedPageComponent = ({ accessType: accessType, contentId: contentId, editDeniedButCanView: editDeniedButCanView, flags: flags, viewLink: viewLink, showSuperAdminGateway: showSuperAdminGateway = true })=>{
    const { formatMessage: formatMessage } = (0, $kSwu1.useIntl)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $9DHhW.useAnalyticsEvents)();
    const [contentType] = (0, $ep3mz.useContentType)();
    const [requestSent, setRequestSent] = (0, $cozmU.useState)(false);
    const [reminderSent, setReminderSent] = (0, $cozmU.useState)(false);
    const accessRequestSubmitIntentRef = (0, $cozmU.useRef)('request');
    const renderServerPlaceholder = (0, $e4o8D.useRenderServerPlaceholder)();
    const { accessStatus: accessStatus } = (0, $bQm3c.useSessionData)();
    const { pendingRequestExists: pendingRequestExists, isLoadingForFirstTime: isLoadingForFirstTime, isPendingRequestResolvedForSSR: isPendingRequestResolvedForSSR, error: pendingAccessRequestExistsError } = (0, $dmDX7.usePendingRequestExists)({
        contentId: contentId,
        preferPreloadedData: (0, $6mKj3.expValEquals)('cc_mohiti_restricted_content_screen_ab_exp', 'isEnabled', true)
    });
    const { from: from } = (0, $3GP6F.useFeatureCodesInURL)();
    const makeLinkClickedHandler = (buttonLocation)=>()=>{
            createAnalyticsEvent({
                type: 'sendUIEvent',
                data: {
                    action: 'clicked',
                    actionSubject: 'button',
                    actionSubjectId: 'viewPageButton',
                    source: 'restrictedPageScreen',
                    attributes: {
                        buttonLocation: buttonLocation,
                        accessType: accessType || 'unspecified',
                        contentId: contentId,
                        contentType: contentType
                    }
                }
            }).fire(); // If the link was in a flag, hide the flag, since this might be an
            // SPA transition.
            flags.hideFlag($cc1cd145e3df0c55$var$SUCCESS_FLAG_ID);
        };
    const handleGoHomeClick = ()=>{
        createAnalyticsEvent({
            type: 'sendUIEvent',
            data: {
                action: 'clicked',
                actionSubject: 'button',
                actionSubjectId: 'restrictedPageGoHomeButton',
                source: 'restrictedPageScreen',
                attributes: {
                    accessType: accessType || 'unspecified',
                    contentId: contentId,
                    contentType: contentType,
                    editDeniedButCanView: editDeniedButCanView
                }
            }
        }).fire();
    }; /** Displays the success or failure flags after access is requested */ 
    const handleRequestComplete = (result)=>{
        const requestSuccessful = result?.requestPageAccess?.displayName;
        const isReminder = accessRequestSubmitIntentRef.current === 'reminder';
        if (requestSuccessful) {
            flags.showSuccessFlag({
                isAutoDismiss: true,
                id: $cc1cd145e3df0c55$var$SUCCESS_FLAG_ID,
                title: formatMessage(isReminder ? $cc1cd145e3df0c55$var$i18n.reminderSentTitle : $cc1cd145e3df0c55$var$i18n.requestSentTitle),
                actions: editDeniedButCanView ? [
                    {
                        content: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kSwu1.FormattedMessage), {
                            id: "no-permission.restricted.page.flag.view-content",
                            defaultMessage: "View the content now"
                        }),
                        onClick: makeLinkClickedHandler('access-requested-flag'),
                        href: viewLink
                    }
                ] : undefined
            });
            if (isReminder) setReminderSent(true);
            else setRequestSent(true);
        } else flags.showErrorFlag({
            isAutoDismiss: true,
            title: formatMessage(isReminder ? $cc1cd145e3df0c55$var$i18n.reminderFailedTitle : $cc1cd145e3df0c55$var$i18n.requestFailedTitle),
            description: formatMessage(isReminder ? $cc1cd145e3df0c55$var$i18n.reminderFailedBody : $cc1cd145e3df0c55$var$i18n.requestFailedBody)
        });
    };
    const handleRequestError = ()=>{
        const isReminder = accessRequestSubmitIntentRef.current === 'reminder';
        flags.showErrorFlag({
            isAutoDismiss: true,
            title: formatMessage(isReminder ? $cc1cd145e3df0c55$var$i18n.reminderFailedTitle : $cc1cd145e3df0c55$var$i18n.requestFailedTitle),
            description: formatMessage(isReminder ? $cc1cd145e3df0c55$var$i18n.reminderFailedBody : $cc1cd145e3df0c55$var$i18n.requestFailedBody)
        });
    };
    const [requestAccess] = (0, $308Wd.useMutationInterop)($cc1cd145e3df0c55$var$RestrictedPageRequestPageAccessMutationGraphQL, {
        variables: {
            requestPageAccessInput: {
                pageId: contentId ?? '',
                accessType: accessType === 'edit' ? 'EDIT' : 'VIEW'
            }
        },
        onCompleted: handleRequestComplete,
        onError: handleRequestError,
        __callerPackage__: "no-permission"
    });
    const renderTitle = ()=>{
        if (accessType !== 'edit') {
            if ((0, $6mKj3.expValEquals)('cc_mohiti_restricted_content_screen_ab_exp', 'isEnabled', true)) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kSwu1.FormattedMessage), {
                id: "no-permission.restricted.page.view.title.mohiti",
                defaultMessage: "This content is locked for now"
            });
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kSwu1.FormattedMessage), {
                id: "no-permission.restricted.page.view.title",
                defaultMessage: "You\u2019ve stumbled on restricted content"
            });
        }
        if (editDeniedButCanView) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kSwu1.FormattedMessage), {
            id: "no-permission.restricted.page.edit-but-can-view.title",
            defaultMessage: "You don\u2019t have access to edit this content"
        });
        if ((0, $6mKj3.expValEquals)('cc_mohiti_restricted_content_screen_ab_exp', 'isEnabled', true)) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kSwu1.FormattedMessage), {
            id: "no-permission.restricted.page.edit.title.mohiti",
            defaultMessage: "Ask the owner to pass the pen"
        });
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kSwu1.FormattedMessage), {
            id: "no-permission.restricted.page.edit.title",
            defaultMessage: "Editing is restricted for this content"
        });
    };
    const renderMessage = ()=>accessType === 'inherited' && !(0, $6mKj3.expVal)('confluence_access_request_updates', 'isEnabled', false) ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kSwu1.FormattedMessage), {
            id: "no-permission.restricted.page.inherited.message",
            defaultMessage: "This is because it\u2019s inheriting restrictions from a parent item. A space admin or the person who shared this content may be able to give you access."
        }) : renderAccessRequest();
    const renderPendingAccessMessage = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kSwu1.FormattedMessage), {
            id: "no-permission.restricted.page.pending-access.message",
            defaultMessage: "We\u2019ve already notified the owner that you need access. If you\u2019re in a hurry, you can send a quick nudge."
        });
    const submitAccessRequest = async (intent)=>{
        if (intent === 'reminder' && reminderSent) return;
        try {
            accessRequestSubmitIntentRef.current = intent;
            setRequestAccessButtonLoading(true);
            setAnimateTextDirection(true);
            createAnalyticsEvent({
                type: 'sendUIEvent',
                data: {
                    action: 'clicked',
                    actionSubject: 'button',
                    actionSubjectId: intent === 'reminder' ? 'sendReminderButton' : 'requestAccessButton',
                    source: 'restrictedPageScreen',
                    attributes: {
                        accessType: accessType || 'unspecified',
                        contentId: contentId,
                        contentType: contentType,
                        editDeniedButCanView: editDeniedButCanView,
                        submitIntent: intent
                    }
                }
            }).fire();
            await requestAccess();
        } catch  {}
        setRequestAccessButtonLoading(false);
    };
    const handleRequestAccessClick = ()=>submitAccessRequest('request');
    const handleSendReminderClick = ()=>submitAccessRequest('reminder');
    const [animateTextDirection, setAnimateTextDirection] = (0, $cozmU.useState)(false);
    const [requestAccessButtonLoading, setRequestAccessButtonLoading] = (0, $cozmU.useState)(false);
    const renderRequestSentConfirmation = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $57p4j.default), {
            entranceDirection: animateTextDirection ? 'right' : undefined,
            distance: "proportional",
            key: "confirmation-text-animation"
        }, ({ ...props })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($cc1cd145e3df0c55$var$RequestConfirmationTextContainer, props, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $1l0kj.Inline), {
                alignBlock: "center",
                space: "space.050",
                grow: "hug"
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5ZtfK))), {
                label: "",
                color: "var(--ds-icon-subtlest, #6B6E76)",
                size: "small"
            }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4aRua.Text), {
                color: "color.text.subtlest",
                weight: "medium"
            }, accessType === 'edit' && !pendingRequestExists ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kSwu1.FormattedMessage), {
                id: "no-permission.restricted.page.request.edit-access.request-sent-confirmation",
                defaultMessage: "Edit requested"
            }) : // This serves double purpose for confirming VIEW requests or
            // Confirming there's an existing request of unknown accessType
            // This happens when the page loads and we call the API to know if there's a request.
            // Currently it doesn't tell us what request type it is, so we make it sound generic
            // Until the API gets updated, which should be easy
            /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kSwu1.FormattedMessage), {
                id: "no-permission.restricted.page.request.view-access.request-sent-confirmation",
                defaultMessage: "Access requested"
            })))));
    const renderRequestAccessButtonMessage = ()=>{
        if (accessType === 'edit') {
            if ((0, $6mKj3.expValEquals)('cc_mohiti_restricted_content_screen_ab_exp', 'isEnabled', true)) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kSwu1.FormattedMessage), {
                id: "no-permission.restricted.page.request.edit-access.mohiti",
                defaultMessage: "Request edit access"
            });
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kSwu1.FormattedMessage), {
                id: "no-permission.restricted.page.request.edit-access",
                defaultMessage: "Ask to edit"
            });
        }
        if ((0, $6mKj3.expValEquals)('cc_mohiti_restricted_content_screen_ab_exp', 'isEnabled', true)) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kSwu1.FormattedMessage), {
            id: "no-permission.restricted.page.request.view-access.mohiti",
            defaultMessage: "Request access"
        });
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kSwu1.FormattedMessage), {
            id: "no-permission.restricted.page.request.view-access",
            defaultMessage: "Ask for access"
        });
    };
    const renderRequestAccessButton = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $57p4j.default), {
            duration: "large",
            key: "primary-button-animation"
        }, ({ ...props })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("div", props, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $ad7Ou.default), {
                onClick: handleRequestAccessClick,
                appearance: "primary",
                isLoading: requestAccessButtonLoading
            }, renderRequestAccessButtonMessage())));
    const isLicensed = !!accessStatus && $cc1cd145e3df0c55$var$LICENSED_ACCESS_STATUSES.has(accessStatus);
    const renderGoHomeMessage = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kSwu1.FormattedMessage), {
            id: "no-permission.restricted.page.go-home",
            defaultMessage: "Go home"
        });
    const wrapWithHomePreloader = (button)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $hXDOc.HoverPreloader), {
            name: "restricted-page-home",
            preloadUrl: (0, $1NBp8.HOME).toUrl(),
            preloadOptions: (0, $hXDOc.PreloadingPresets).everything
        }, button);
    const goHomeButtonProps = {
        href: (0, $1NBp8.HOME).toUrl(),
        children: renderGoHomeMessage(),
        onClick: handleGoHomeClick
    }; // Matches renderButtonOrExistingRequestText()
    const canRenderRequestAction = !isLoadingForFirstTime && !pendingAccessRequestExistsError && !renderServerPlaceholder && isLicensed;
    const shouldRenderWaitingForAccess = accessType !== 'edit' && Boolean(contentId) && canRenderRequestAction && pendingRequestExists && (0, $6mKj3.expValEquals)('cc_mohiti_restricted_content_screen_ab_exp', 'isEnabled', true);
    const currentIllustration = (()=>{
        if (accessType === 'edit') return (0, $6mKj3.expValEquals)('cc_mohiti_restricted_content_screen_ab_exp', 'isEnabled', true) ? $cc1cd145e3df0c55$var$requestEditAccessMohitiIllustration : $cc1cd145e3df0c55$var$requestEditAccessIllustration;
        if ((0, $6mKj3.expValEquals)('cc_mohiti_restricted_content_screen_ab_exp', 'isEnabled', true)) return $cc1cd145e3df0c55$var$restrictedContentMohitiIllustration;
        return $cc1cd145e3df0c55$var$restrictedContentIllustration;
    })();
    const renderButtonOrExistingRequestText = ()=>{
        if (isLoadingForFirstTime || pendingAccessRequestExistsError || renderServerPlaceholder || !isLicensed) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
            xcss: $cc1cd145e3df0c55$var$styles.buttonPlaceholder
        });
        if (pendingRequestExists || requestSent) return renderRequestSentConfirmation();
        return renderRequestAccessButton();
    };
    const renderManualRequestAccessMessage = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kSwu1.FormattedMessage), {
            id: "no-permission.restricted.page.manual.request.access.from.author",
            defaultMessage: "Only some people can view this. If you think you should have access, try asking the person who sent you here for help."
        });
    const renderViewAccessMessage = ()=>{
        if ((0, $6mKj3.expValEquals)('cc_mohiti_restricted_content_screen_ab_exp', 'isEnabled', true)) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kSwu1.FormattedMessage), {
            id: "no-permission.restricted.page.view.request.access.mohiti",
            defaultMessage: "You don\u2019t have permission to view this content. If you want to view it, you can ask the owner."
        });
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kSwu1.FormattedMessage), {
            id: "no-permission.restricted.page.view.request.access.from.author",
            defaultMessage: "Only some people can view this content. If you want access, you can ask the owner."
        });
    };
    const getButtonAlignment = ()=>{
        if ((0, $6mKj3.expValEquals)('cc_mohiti_restricted_content_screen_ab_exp', 'isEnabled', true)) return 'center';
        return 'default';
    };
    const renderInlineGoHomeButton = ()=>{
        if (!(0, $6mKj3.expValEquals)('cc_mohiti_restricted_content_screen_ab_exp', 'isEnabled', true)) return null;
        return wrapWithHomePreloader(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $eKMV3.default), {
            href: (0, $1NBp8.HOME).toUrl(),
            onClick: handleGoHomeClick
        }, renderGoHomeMessage()));
    };
    const renderAccessRequestMessage = ()=>{
        if (accessType !== 'edit') return renderViewAccessMessage();
        if ((0, $6mKj3.expValEquals)('cc_mohiti_restricted_content_screen_ab_exp', 'isEnabled', true)) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kSwu1.FormattedMessage), {
            id: "no-permission.restricted.page.edit.request.access.mohiti",
            defaultMessage: "You don\u2019t have permission to edit this content. If you want to edit it, you can ask the owner."
        });
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kSwu1.FormattedMessage), {
            id: "no-permission.restricted.page.edit.request.access.from.author",
            defaultMessage: "Only some people can edit this content. If you want to edit it, you can ask the owner."
        });
    };
    const renderAccessRequestButtons = ()=>{
        if (accessType === 'edit') return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($cc1cd145e3df0c55$var$ButtonContainer, {
            isMobile: (0, $8dwdz.shouldShowMobileWeb)(),
            align: getButtonAlignment()
        }, editDeniedButCanView && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $eKMV3.default), {
            href: viewLink,
            onClick: makeLinkClickedHandler('main')
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kSwu1.FormattedMessage), {
            id: "no-permission.restricted.page.view-content",
            defaultMessage: "View content"
        })), renderButtonOrExistingRequestText(), !editDeniedButCanView ? renderInlineGoHomeButton() : null);
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($cc1cd145e3df0c55$var$ButtonContainer, {
            isMobile: (0, $8dwdz.shouldShowMobileWeb)(),
            align: getButtonAlignment()
        }, renderButtonOrExistingRequestText(), renderInlineGoHomeButton());
    }; /** Renders the access request call to action and message */ 
    const renderAccessRequest = ()=>{
        if (!contentId) return renderManualRequestAccessMessage();
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).Fragment, null, renderAccessRequestMessage(), renderAccessRequestButtons());
    };
    const canRenderMohitiRequestActions = contentId && accessType !== 'edit' && canRenderRequestAction && !pendingRequestExists && !requestSent && !editDeniedButCanView && (0, $6mKj3.expValEquals)('cc_mohiti_restricted_content_screen_ab_exp', 'isEnabled', true);
    const shouldRenderMohitiRequestActions = canRenderMohitiRequestActions && (accessType !== 'inherited' || (0, $6mKj3.expVal)('confluence_access_request_updates', 'isEnabled', false));
    const isPendingRequestUnresolved = accessType !== 'edit' && Boolean(contentId) && (isLoadingForFirstTime || renderServerPlaceholder); // Whether to show the "waiting for access" title/message.
    // When the pending-request status is preloaded at SSR we render the resolved message in the server
    // HTML; when it isn't we render the default request-access message and swap post-hydration.
    const shouldRenderWaitingForAccessMessage = accessType !== 'edit' && Boolean(contentId) && isLicensed && !pendingAccessRequestExistsError && isPendingRequestResolvedForSSR && pendingRequestExists && (0, $6mKj3.expValEquals)('cc_mohiti_restricted_content_screen_ab_exp', 'isEnabled', true); // Default "ask the owner for access" message for the Mohiti view screen, shown whenever we're not
    // showing the "waiting for access" message — including while the lookup loads (SSR) so text never
    // blanks. requestSent is excluded so it falls through to the inline "Access requested" confirmation.
    const canRenderMohitiDefaultMessage = accessType !== 'edit' && Boolean(contentId) && !requestSent && (0, $6mKj3.expValEquals)('cc_mohiti_restricted_content_screen_ab_exp', 'isEnabled', true);
    const shouldRenderMohitiDefaultMessage = canRenderMohitiDefaultMessage && (accessType !== 'inherited' || (0, $6mKj3.expVal)('confluence_access_request_updates', 'isEnabled', false));
    const hasPendingAccessRequest = accessType !== 'edit' && Boolean(contentId) && canRenderRequestAction && pendingRequestExists;
    const errorMessage = (()=>{
        if (shouldRenderWaitingForAccessMessage) return renderPendingAccessMessage();
        if (shouldRenderMohitiDefaultMessage) return renderAccessRequestMessage();
        return renderMessage();
    })();
    const renderErrorTitle = ()=>{
        switch(true){
            case shouldRenderWaitingForAccessMessage:
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kSwu1.FormattedMessage), {
                    id: "no-permission.restricted.page.pending-access.title",
                    defaultMessage: "Your request is in the works"
                });
            default:
                return renderTitle();
        }
    };
    const primaryButtonProps = (()=>{
        if (shouldRenderWaitingForAccess) return {
            children: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kSwu1.FormattedMessage), {
                id: "no-permission.restricted.page.pending-access.send-reminder",
                defaultMessage: "Send a reminder"
            }),
            onClick: handleSendReminderClick,
            isDisabled: reminderSent,
            isLoading: requestAccessButtonLoading
        };
        if (shouldRenderMohitiRequestActions) return {
            children: renderRequestAccessButtonMessage(),
            onClick: handleRequestAccessClick,
            isLoading: requestAccessButtonLoading
        };
        return undefined;
    })();
    const secondaryButtonProps = shouldRenderWaitingForAccess || shouldRenderMohitiRequestActions ? goHomeButtonProps : undefined;
    (0, $cozmU.useEffect)(()=>{
        // Defer the screen event until the pending-access-request lookup has settled, so
        // `hasPendingAccessRequest` reflects the user's actual request state rather than
        // the transient loading state.
        if (isPendingRequestUnresolved) return;
         // Yes, it's always a 'page' viewed, even if contentType is something
        // else. It's just how this screen is registered.
        createAnalyticsEvent({
            type: 'sendScreenEvent',
            data: {
                name: 'restrictedPageViewed',
                action: 'viewed',
                actionSubject: 'page',
                actionSubjectId: 'restrictedPage',
                attributes: {
                    accessType: accessType || 'unspecified',
                    contentId: contentId,
                    contentType: contentType,
                    editDeniedButCanView: editDeniedButCanView,
                    from: from,
                    hasPendingAccessRequest: hasPendingAccessRequest
                }
            }
        }).fire();
    }, [
        accessType,
        contentId,
        contentType,
        editDeniedButCanView,
        viewLink,
        createAnalyticsEvent,
        from,
        isPendingRequestUnresolved,
        hasPendingAccessRequest
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $auKqk.ErrorPageComponent), {
        errorImage: currentIllustration.light,
        errorImageDark: currentIllustration.dark,
        layout: (0, $6mKj3.expValEquals)('cc_mohiti_restricted_content_screen_ab_exp', 'isEnabled', true) ? 'centered' : 'default',
        errorTitle: renderErrorTitle(),
        errorMessage: errorMessage,
        primaryButtonProps: primaryButtonProps,
        secondaryButtonProps: secondaryButtonProps,
        secondaryButtonWrapper: wrapWithHomePreloader
    }, showSuperAdminGateway && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $c9iq1.SuperAdminGateway), {
        type: "page",
        contentId: contentId
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $1eaCJ.ExperienceSuccess), {
        name: (0, $irVI7.RESTRICTED_PAGE_EXPERIENCE)
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $lLRfG.PageLoadEnd), {
        metric: (0, $f3euL.INACCESSIBLE_PAGE_LOAD),
        customData: {
            ...$cc1cd145e3df0c55$var$CUSTOM_ATTRIBUTES,
            contentId: contentId
        }
    }));
};
const $cc1cd145e3df0c55$var$RestrictedPageWithCanViewQuery = (props)=>{
    const { accessType: accessType, contentId: contentId } = props;
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $9DHhW.useAnalyticsEvents)();
    const skipViewQuery = accessType !== 'edit';
    const spaceKey = (0, $cLo2u.useSpaceKey)();
    const { replace: replace } = (0, $dPJCf.useRouteActions)();
    const experienceTracker = (0, $cozmU.useContext)((0, $1kHsc.ExperienceTrackerContext)); // While a view-denied requestor waits for their access request, poll for the
    // content's actual view access so we can refresh once it is (effectively)
    // granted, rather than relying on the access-decision signal alone.
    const pollForViewAccess = accessType === 'view' && Boolean(contentId) && (0, $6mKj3.expVal)('confluence_access_request_updates', 'isEnabled', false);
    const { data: data, error: error, loading: loading, stopPolling: stopPolling } = (0, $jMyy4.useQueryInterop)($cc1cd145e3df0c55$var$RestrictedPageWithCanViewQueryGraphQL, {
        variables: {
            id: contentId ?? ''
        },
        skip: skipViewQuery && !pollForViewAccess,
        fetchPolicy: 'network-only',
        pollInterval: pollForViewAccess ? 5000 : undefined,
        notifyOnNetworkStatusChange: pollForViewAccess,
        __callerPackage__: "no-permission"
    }); // The content resolving to a non-draft means the current user can access it.
    // Drafts are excluded to match the existing viewability semantics.
    const contentResolvedAndViewable = Boolean(data?.singleContent) && data?.singleContent?.status !== 'draft';
    const editDeniedButCanView = !skipViewQuery && contentResolvedAndViewable; // In the view-poll case, the content becoming viewable means the requestor can
    // now access it; stop polling and refresh so the real content renders.
    const contentNowViewable = pollForViewAccess && contentResolvedAndViewable;
    (0, $cozmU.useEffect)(()=>{
        if (contentNowViewable) {
            stopPolling();
            window.location.reload();
        }
    }, [
        contentNowViewable,
        stopPolling
    ]);
    const viewLink = editDeniedButCanView ? `${0, $jlIaF.CONTEXT_PATH}${data?.singleContent?.links?.webui}` : null;
    const canBeSuperAdmin = Boolean(data?.user?.confluence?.roles?.canBeSuperAdmin); // Only redirect user if:
    // 1. They have a viewLink available.
    // 2. They can't be super admin.
    const shouldRedirectToView = spaceKey && viewLink && !canBeSuperAdmin;
    (0, $cozmU.useEffect)(()=>{
        if (shouldRedirectToView) {
            createAnalyticsEvent({
                type: 'sendTrackEvent',
                data: {
                    action: 'redirected',
                    actionSubject: 'redirectToViewMode',
                    source: 'restrictedPageScreen',
                    attributes: {
                        accessType: accessType,
                        contentId: contentId
                    }
                }
            }).fire();
            experienceTracker.succeed({
                name: (0, $irVI7.RESTRICTED_PAGE_EXPERIENCE)
            });
            if ((0, $6mKj3.expValEquals)('confluence_edit_page_restricted_redirect_ttvc_fix', 'isEnabled', true)) // Abort the in-flight edit-page UFO interaction so this redirect isn't recorded as a
            // successful edit-page load.
            (0, $a33Aa.abortAll)('transition');
            replace((0, $1NBp8.VIEW_PAGE).toUrl({
                spaceKey: spaceKey,
                contentId: contentId
            }, {
                query: {
                    redirectedFromRestrict: 'true'
                }
            }));
        }
    }, [
        createAnalyticsEvent,
        contentId,
        shouldRedirectToView,
        accessType,
        spaceKey,
        replace,
        experienceTracker
    ]); // In the view-poll case the restricted screen must render immediately while the
    // access check runs in the background, so loading is only blocking for the
    // edit case's one-shot redirect check.
    if (loading && !pollForViewAccess) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $fxpoI.ShowSpinnerAfterDelay), null);
    else {
        /**
     * Usually, if the user doesn't have permission to view the page, the
     * query succeeds with `singleContent: null`. But occasionally we get a
     * 401 or 403, and we'd consider those to be expected errors.
     */ let hasUnhandledError = false;
        if (error) {
            if ((0, $7LI3Q.isUnauthorizedError)(error)) (0, $7Sm4c.markErrorAsHandled)(error);
            else if ((0, $1uFM6.isUnauthorizedError)(error)) (0, $7Sm4c.markErrorAsHandled)(error);
            else hasUnhandledError = true;
        }
        return shouldRedirectToView ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $fxpoI.ShowSpinnerAfterDelay), null) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).Fragment, null, hasUnhandledError && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $gfIPU.ExperienceFailure), {
            name: (0, $irVI7.RESTRICTED_PAGE_EXPERIENCE),
            error: error
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $b3j2Y.ErrorDisplay), {
            error: error
        })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($cc1cd145e3df0c55$var$RestrictedPageComponent, {
            ...props,
            editDeniedButCanView: editDeniedButCanView,
            viewLink: viewLink
        }));
    }
};
const $cc1cd145e3df0c55$export$4242cfff65d64b16 = (props)=>{
    if (props.contentId && window['__SPACE_RESTRICTED_ERROR__'] === props.contentId && (0, $6mKj3.expVal)('confluence_frontend_ssr_space_not_found', 'isEnabled', false)) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4PPzL.ErrorBoundary), {
        attribution: (0, $3IBnw.Attribution).PERMISSIONS_EXPERIENCE
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $9at9H.RestrictedSpace), {
        contentId: props.contentId
    }));
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4PPzL.ErrorBoundary), {
        attribution: (0, $3IBnw.Attribution).ADMIN_EXPERIENCE
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $ln0hx.ExperienceStart), {
        name: (0, $irVI7.RESTRICTED_PAGE_EXPERIENCE)
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kNIYN.Subscribe), {
        to: [
            (0, $gqqjz.FlagsStateContainer)
        ]
    }, (flags)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($cc1cd145e3df0c55$var$RestrictedPageWithCanViewQuery, {
            ...props,
            flags: flags
        })));
};
module.exports["RestrictedPage"] = $cc1cd145e3df0c55$export$4242cfff65d64b16;

});

parcelRegister("e5EnV", function(module, exports) {
/**
 * @generated SignedSource<<19f88e77d3cfba146c135d602dcd850a>>
 * @relayHash 6cd75834f128f4e69b90e03b31603fd0
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 12b9ea0b2a8549a655e6db18139e709c6bf2e6d45eff5ec0488c52b8b8309362
const $e4798d13ae2c4a75$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "id"
        }
    ], v1 = {
        "kind": "ScalarField",
        "name": "id"
    }, v2 = [
        {
            "args": [
                {
                    "kind": "Variable",
                    "name": "id",
                    "variableName": "id"
                }
            ],
            "concreteType": "Content",
            "kind": "LinkedField",
            "name": "singleContent",
            "plural": false,
            "selections": [
                v1 /*: any*/ ,
                {
                    "kind": "ScalarField",
                    "name": "status"
                },
                {
                    "concreteType": "LinksDownloadEdituiWebuiContextSelfTinyuiCollectionBase",
                    "kind": "LinkedField",
                    "name": "links",
                    "plural": false,
                    "selections": [
                        {
                            "kind": "ScalarField",
                            "name": "webui"
                        }
                    ]
                }
            ]
        },
        {
            "alias": "user",
            "args": [
                {
                    "kind": "Literal",
                    "name": "current",
                    "value": true
                }
            ],
            "concreteType": "AtlassianUser",
            "kind": "LinkedField",
            "name": "confluence_atlassianUser",
            "plural": false,
            "selections": [
                v1 /*: any*/ ,
                {
                    "concreteType": "ConfluenceUser",
                    "kind": "LinkedField",
                    "name": "confluence",
                    "plural": false,
                    "selections": [
                        {
                            "concreteType": "GraphQLConfluenceUserRoles",
                            "kind": "LinkedField",
                            "name": "roles",
                            "plural": false,
                            "selections": [
                                {
                                    "kind": "ScalarField",
                                    "name": "canBeSuperAdmin"
                                }
                            ]
                        }
                    ]
                }
            ],
            "storageKey": "confluence_atlassianUser(current:true)"
        }
    ];
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "name": "RestrictedPageWithCanViewQuery",
            "selections": v2 /*: any*/ ,
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "RestrictedPageWithCanViewQuery",
            "selections": v2 /*: any*/ 
        },
        "params": {
            "cacheID": "6cd75834f128f4e69b90e03b31603fd0",
            "id": "12b9ea0b2a8549a655e6db18139e709c6bf2e6d45eff5ec0488c52b8b8309362",
            "metadata": {},
            "name": "RestrictedPageWithCanViewQuery",
            "operationKind": "query",
            "text": "query RestrictedPageWithCanViewQuery($id:ID!){singleContent(id:$id){id,status,links{webui}},user:confluence_atlassianUser(current:true){id,confluence{roles{canBeSuperAdmin}}}}"
        }
    };
}();
$e4798d13ae2c4a75$var$node.hash = "cac9cbea2e6f98b7e3ef1e383776a339";
var $e4798d13ae2c4a75$export$2e2bcd8739ae039 = $e4798d13ae2c4a75$var$node;
module.exports["default"] = $e4798d13ae2c4a75$export$2e2bcd8739ae039;

});

parcelRegister("gfIPU", function(module, exports) {

var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");


var $1kHsc = parcelRequire("1kHsc");

function $5675860ef242c9e4$export$eed1d73ebdd8c7ab(t0) {
    const $ = (0, $bDgLe.c)(6);
    const { name: name, error: error, attributes: attributes } = t0;
    const experienceTracker = (0, $cozmU.useContext)((0, $1kHsc.ExperienceTrackerContext));
    let t1;
    let t2;
    if ($[0] !== attributes || $[1] !== error || $[2] !== experienceTracker || $[3] !== name) {
        t1 = ()=>experienceTracker.fail({
                name: name,
                error: error,
                attributes: attributes
            });
        t2 = [
            experienceTracker,
            name,
            error,
            attributes
        ];
        $[0] = attributes;
        $[1] = error;
        $[2] = experienceTracker;
        $[3] = name;
        $[4] = t1;
        $[5] = t2;
    } else {
        t1 = $[4];
        t2 = $[5];
    }
    (0, $cozmU.useEffect)(t1, t2);
    return null;
}
module.exports["ExperienceFailure"] = $5675860ef242c9e4$export$eed1d73ebdd8c7ab;

});

parcelRegister("3GP6F", function(module, exports) {

var $cozmU = parcelRequire("cozmU");


var $KDAt0 = parcelRequire("KDAt0");


var $dPJCf = parcelRequire("dPJCf");


var $lpPVE = parcelRequire("lpPVE");


var $71GjD = parcelRequire("71GjD");




const $9bc3195b956679d5$export$eddc138581adbc11 = ()=>{
    const history = (0, $dPJCf.useHistory)();
    const location = (0, $KDAt0.useLocation)();
    const queryParams = location?.search;
    const queryParamsFeatureCodes = (0, $lpPVE.getFeatureCodes)(new URLSearchParams(queryParams));
    const [featureCodes, setFeatureCodes] = (0, $cozmU.useState)(queryParamsFeatureCodes);
    (0, $cozmU.useEffect)(()=>{
        if (queryParams && queryParams.includes((0, $71GjD.FEATURE_CODES_QUERY_PARAM))) {
            setFeatureCodes(queryParamsFeatureCodes);
            (0, $lpPVE.hideFeatureCodesQueryParam)(history, location);
        }
    }, [
        history,
        location,
        queryParams,
        queryParamsFeatureCodes
    ]);
    return featureCodes;
};
module.exports["useFeatureCodesInURL"] = $9bc3195b956679d5$export$eddc138581adbc11;

});

parcelRegister("lpPVE", function(module, exports) {

var $71GjD = parcelRequire("71GjD");

const $d9de10c6417158bd$export$d347e131abf45bea = (href, featureCodes)=>{
    if (!featureCodes.length) return href;
    const [path, queryString] = href.split('?');
    const searchParams = new URLSearchParams(queryString);
    // If the query param already exists, append the new feature codes to the existing ones
    if (searchParams.has((0, $71GjD.FEATURE_CODES_QUERY_PARAM))) {
        const existingFeatureCodes = searchParams.get((0, $71GjD.FEATURE_CODES_QUERY_PARAM)) || '';
        const newFeatureCodes = [
            ...new Set([
                ...existingFeatureCodes.split(','),
                ...featureCodes
            ])
        ];
        searchParams.set((0, $71GjD.FEATURE_CODES_QUERY_PARAM), newFeatureCodes.join(','));
    } else searchParams.append((0, $71GjD.FEATURE_CODES_QUERY_PARAM), featureCodes.join(','));
    const newQueryString = searchParams.toString();
    return newQueryString ? `${path}?${newQueryString}` : path;
};
const $d9de10c6417158bd$export$3c2127388df02347 = (queryParams)=>{
    const featureCodes = queryParams.get((0, $71GjD.FEATURE_CODES_QUERY_PARAM))?.split(',');
    const fromCode = featureCodes?.find((code)=>Object.values((0, $71GjD.FeatureCode)).includes(code));
    return {
        from: fromCode
    };
};
const $d9de10c6417158bd$export$241f453208292937 = (history, location)=>{
    if (!location?.search?.includes((0, $71GjD.FEATURE_CODES_QUERY_PARAM))) return;
    const searchParams = new URLSearchParams(location.search);
    searchParams.delete((0, $71GjD.FEATURE_CODES_QUERY_PARAM));
    const search = searchParams.toString();
    history?.replace?.({
        ...location,
        search: search ? `?${search}` : ''
    });
};
const $d9de10c6417158bd$export$866aaa0a921ee13d = (existingFeatureCodes, featureCodeToCheck)=>{
    return existingFeatureCodes.includes(featureCodeToCheck);
};
const $d9de10c6417158bd$export$84f5742c2ddda28f = (existingFeatureCodes, featureCodeToAdd)=>{
    if ($d9de10c6417158bd$export$866aaa0a921ee13d(existingFeatureCodes, featureCodeToAdd)) return existingFeatureCodes;
    return [
        ...existingFeatureCodes,
        featureCodeToAdd
    ];
};
const $d9de10c6417158bd$export$f2b1b8a892016485 = (existingFeatureCodes, featureCodeToRemove)=>{
    if (!$d9de10c6417158bd$export$866aaa0a921ee13d(existingFeatureCodes, featureCodeToRemove)) return existingFeatureCodes;
    return existingFeatureCodes.filter((code)=>code !== featureCodeToRemove);
};
module.exports["generatePathWithFeatureCodesQueryParam"] = $d9de10c6417158bd$export$d347e131abf45bea;
module.exports["getFeatureCodes"] = $d9de10c6417158bd$export$3c2127388df02347;
module.exports["hideFeatureCodesQueryParam"] = $d9de10c6417158bd$export$241f453208292937;

});

parcelRegister("71GjD", function(module, exports) {
/**
 * Feature attribution enum for tracking feature usage/attribution
 *
 * @note All feature codes are intended to be 8 characters or less in length
 *
 * @see https://hello.atlassian.net/wiki/x/lQxt9Q
 */ var $9d2fac30cbee1d6f$export$661babcb078ff919 = /*#__PURE__*/ function(FeatureCode) {
    /** Confluence Home Feeds (Following and Popular) **/ FeatureCode["HOME_FEED"] = "HOMEFEED";
    /** Confluence End of Page Recommendations (Related Pages) **/ FeatureCode["EOP_REC"] = "EOPREC";
    /** Confluence End of Page Recommendations (Related Pages) Hover Card **/ FeatureCode["EOP_REC_CARD"] = "EOPCARD";
    /** Confluence Page Tree **/ FeatureCode["PAGE_TREE"] = "PAGETREE";
    /** Confluence Page Tree Card **/ FeatureCode["PAGE_TREE_CARD"] = "TREECARD";
    /** Following Feed email **/ FeatureCode["FOLLOWING_FEED_EMAIL"] = "FLLWEML";
    /** Popular Feed email **/ FeatureCode["POPULAR_FEED_EMAIL"] = "PPLREML";
    FeatureCode["ADMIN_KEY_EMAIL"] = "ADMINEML";
    FeatureCode["ATTACHMENT_EMAILS"] = "ATTCHEML";
    FeatureCode["BATCH_EMAIL"] = "BATCHEML";
    FeatureCode["BLOG_CREATED_EMAIL"] = "BLOGEML";
    FeatureCode["BULK_ARCHIVE_EMAIL"] = "BLKAREML";
    FeatureCode["BULK_OWNER_CHANGE_EMAIL"] = "BLKOWEML";
    FeatureCode["CONFLUENCE_WRAPPED_EMAIL"] = "WRAPEML";
    FeatureCode["CONTACT_ADMINISTRATORS_EMAIL"] = "CTADMEML";
    FeatureCode["CONTENT_OWNER_CHANGE_EMAIL"] = "OWNREML";
    FeatureCode["CONTENT_REDACTION_EMAIL"] = "RDCTDEML";
    FeatureCode["EXCO_ADDED_TO_SPACE_EMAIL"] = "EXCASEML";
    FeatureCode["EXCO_REQUEST_ACCESS_EMAIL"] = "EXCRAEML";
    FeatureCode["EXCO_SPACE_READY_EMAIL"] = "EXCSREML";
    FeatureCode["IMPORTER_NOTIFICATIONS"] = "IMPRTNTF";
    FeatureCode["LIVE_PAGE_PUBLISHED_EMAIL"] = "LPPEML";
    FeatureCode["MENTIONS_EMAIL"] = "MNTNEML";
    FeatureCode["PAGE_CREATED_EMAIL"] = "PAGEEML";
    FeatureCode["REMINDER_EMAIL"] = "RMNDREML";
    FeatureCode["REQUEST_AND_GRANT_ACCESS_EMAILS"] = "REQACEML";
    FeatureCode["REQUEST_AND_GRANT_ACCESS_SLACK"] = "REQACSLK";
    FeatureCode["TASKS_EMAIL"] = "TASKEML";
    FeatureCode["TEAM_CALENDAR_EMAIL"] = "CLNDREML";
    FeatureCode["WHITEBOARD_CREATED_EMAIL"] = "WTBRDEML";
    FeatureCode["CONTENT_REDACTION_IN_APP"] = "RDCTDAPP";
    FeatureCode["DAILY_DIGEST_EMAIL"] = "DIGSTEML";
    FeatureCode["MENTIONS_REMINDER_EMAIL"] = "MNTNREML";
    FeatureCode["PUBLIC_LINK_EMAIL"] = "PBLNKEML";
    FeatureCode["REQUEST_AND_GRANT_ACCESS_IN_APP"] = "REQACAPP";
    FeatureCode["SHARE_AND_RESTRICT_DIALOG"] = "SRDIALOG";
    FeatureCode["ROVO_CHAT_LINK"] = "ROVOCHAT";
    FeatureCode["ROVO_EXTENSION_LINK"] = "ROVOEXT";
    FeatureCode["SEND_TO_DESKTOP_EMAIL"] = "SNDDSKEML";
    return FeatureCode;
}({});
const $9d2fac30cbee1d6f$export$18fd2ee3b879d0cd = 'atl_f';
module.exports["FeatureCode"] = $9d2fac30cbee1d6f$export$661babcb078ff919;
module.exports["FEATURE_CODES_QUERY_PARAM"] = $9d2fac30cbee1d6f$export$18fd2ee3b879d0cd;

});

parcelRegister("dmDX7", function(module, exports) {

var $7NYI2 = parcelRequire("7NYI2");


var $cozmU = parcelRequire("cozmU");


var $jMyy4 = parcelRequire("jMyy4");


var $bQm3c = parcelRequire("bQm3c");


var $6mKj3 = parcelRequire("6mKj3");

const $4aa29e57813b75ee$var$UsePendingRequestExistsQuery = (0, $7NYI2.default);
const $4aa29e57813b75ee$export$5354a7f39c2c364a = ({ contentId: contentId, preferPreloadedData: preferPreloadedData = false })=>{
    const { userId: userId, cloudId: cloudId } = (0, $bQm3c.useSessionData)();
    const shouldSkip = !userId || !cloudId || !contentId || !(0, $6mKj3.expValEquals)('confluence_frontend_existing_access_request_checks', 'cohort', 'experiment');
    const [isLoadingForFirstTime, setIsLoadingForFirstTime] = (0, $cozmU.useState)(!shouldSkip);
    const { data: data, error: error, loading: loading } = (0, $jMyy4.useQueryInterop)($4aa29e57813b75ee$var$UsePendingRequestExistsQuery, {
        variables: {
            cloudId: cloudId,
            accessRequestedAaid: userId ?? '',
            contentId: contentId ?? ''
        },
        skip: shouldSkip,
        fetchPolicy: preferPreloadedData ? 'cache-first' : 'network-only',
        onCompleted: ()=>{
            setIsLoadingForFirstTime(false);
        },
        __callerPackage__: "access-requests"
    });
    // SSR-safe resolution signal, for consumers that render on the server. `true` as soon as the
    // answer is available in the store on the current render — including the server render, when the
    // result was SSR-preloaded and read via `cache-first`. Unlike `isLoadingForFirstTime`, this lets an
    // SSR consumer render the resolved copy directly into the server HTML.
    const isPendingRequestResolvedForSSR = shouldSkip || data !== undefined;
    const pendingRequestExists = Boolean(data?.confluence_pendingRequestExists?.isPendingAccessRequestExists);
    return {
        pendingRequestExists: pendingRequestExists,
        loading: loading,
        error: error,
        isLoadingForFirstTime: isLoadingForFirstTime,
        isPendingRequestResolvedForSSR: isPendingRequestResolvedForSSR
    };
};
module.exports["usePendingRequestExists"] = $4aa29e57813b75ee$export$5354a7f39c2c364a;

});

parcelRegister("7NYI2", function(module, exports) {
/**
 * @generated SignedSource<<4d7ccfc95dff4e3b611db90e9453df55>>
 * @relayHash f8787096f4d42896880d52d9cbd4670c
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID ca265d253ef91a90727e0b2a379d714b1851230382cb448d534c1124fd0266b9
const $3cde78eca68e7b16$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "accessRequestedAaid"
        },
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "cloudId"
        },
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "contentId"
        }
    ], v1 = [
        {
            "args": [
                {
                    "kind": "Variable",
                    "name": "accessRequestedAaid",
                    "variableName": "accessRequestedAaid"
                },
                {
                    "kind": "Variable",
                    "name": "cloudId",
                    "variableName": "cloudId"
                },
                {
                    "kind": "Variable",
                    "name": "contentId",
                    "variableName": "contentId"
                }
            ],
            "concreteType": "ConfluencePendingAccessRequest",
            "kind": "LinkedField",
            "name": "confluence_pendingRequestExists",
            "plural": false,
            "selections": [
                {
                    "kind": "ScalarField",
                    "name": "isPendingAccessRequestExists"
                }
            ]
        }
    ];
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "name": "usePendingRequestExistsQuery",
            "selections": v1 /*: any*/ ,
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "usePendingRequestExistsQuery",
            "selections": v1 /*: any*/ 
        },
        "params": {
            "cacheID": "f8787096f4d42896880d52d9cbd4670c",
            "id": "ca265d253ef91a90727e0b2a379d714b1851230382cb448d534c1124fd0266b9",
            "metadata": {},
            "name": "usePendingRequestExistsQuery",
            "operationKind": "query",
            "text": "query usePendingRequestExistsQuery($accessRequestedAaid:String!,$cloudId:ID!,$contentId:ID!){confluence_pendingRequestExists(accessRequestedAaid:$accessRequestedAaid,cloudId:$cloudId,contentId:$contentId){isPendingAccessRequestExists}}"
        }
    };
}();
$3cde78eca68e7b16$var$node.hash = "4d877c3ca505e954e3d6f173f1138ce0";
var $3cde78eca68e7b16$export$2e2bcd8739ae039 = $3cde78eca68e7b16$var$node;
module.exports["default"] = $3cde78eca68e7b16$export$2e2bcd8739ae039;

});

parcelRegister("hXDOc", function(module, exports) {

var $cozmU = parcelRequire("cozmU");


var $9DHhW = parcelRequire("9DHhW");


var $9wGTI = parcelRequire("9wGTI");

var $b22e252a6b9677fd$export$3c7387d0e5ed624d = /*#__PURE__*/ function(PreloadingMode) {
    PreloadingMode["onlyJS"] = "onlyJS";
    PreloadingMode["onlyJSAndCriticalData"] = "onlyJSAndCriticalData";
    PreloadingMode["everything"] = "everything";
    return PreloadingMode;
}({});
const $b22e252a6b9677fd$var$PRELOAD_TIMER = 100;
const $b22e252a6b9677fd$var$sendAnalyticsEvent = (createAnalyticsEvent, action, name, attributes)=>{
    createAnalyticsEvent({
        type: 'sendTrackEvent',
        data: {
            action: action,
            actionSubject: 'hoverPreloader',
            actionSubjectId: name ?? 'n/a',
            source: 'hoverPreloader',
            attributes: attributes
        }
    }).fire();
};
const $b22e252a6b9677fd$var$preload = (preloadUrl, options = {})=>{
    window.dispatchEvent(new CustomEvent('preloadOnHover', {
        bubbles: true,
        detail: {
            preloadUrl: preloadUrl,
            ...options
        }
    }));
};
const $b22e252a6b9677fd$var$TransitionPreloaderImpl = ({ name: name, children: children, preloadUrl: preloadUrl, preloadOptions: preloadOptions })=>{
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $9DHhW.useAnalyticsEvents)();
    const hoverTimeoutRef = (0, $cozmU.useRef)(null);
    const preloadRef = (0, $cozmU.useRef)(false);
    (0, $cozmU.useEffect)(()=>{
        return ()=>{
            preloadRef.current = false;
            if (hoverTimeoutRef.current) window.clearTimeout(hoverTimeoutRef.current);
        };
    }, []);
    // Here we implement multi-stage preloading. JS can be preloaded immediately and unconditionally.
    // For the rest of the preload options / experiments require at least a timeout, but other cases
    // may require more sophisticated logic to decide when or whether to preload.
    const onMouseEnter = (0, $cozmU.useCallback)(()=>{
        preloadRef.current = false;
        $b22e252a6b9677fd$var$preload(preloadUrl, {
            preloadingMode: "onlyJS"
        });
        // Do not proceed to the next stage if only JS preloading is enabled
        if (preloadOptions?.preloadingMode === "onlyJS") return;
        // Trigger next preloading stage either if everything is enabled or if critical data preloading
        // is enabled and the corresponding feature flag is enabled.
        const shouldPreload = preloadOptions?.preloadingMode === "everything" ? true : preloadOptions?.preloadingMode === "onlyJSAndCriticalData" && (0, $9wGTI.fg)('confluence_preload_critical_data');
        if (!shouldPreload) return;
        if (hoverTimeoutRef.current) window.clearTimeout(hoverTimeoutRef.current);
        hoverTimeoutRef.current = window.setTimeout(()=>{
            $b22e252a6b9677fd$var$preload(preloadUrl, preloadOptions);
            preloadRef.current = true;
        }, $b22e252a6b9677fd$var$PRELOAD_TIMER);
    }, [
        preloadUrl,
        preloadOptions
    ]);
    const onMouseLeave = (0, $cozmU.useCallback)(()=>{
        if (hoverTimeoutRef.current) window.clearTimeout(hoverTimeoutRef.current);
        if (preloadRef.current) $b22e252a6b9677fd$var$sendAnalyticsEvent(createAnalyticsEvent, 'preloadAndLeave', name, {
            preloadingMode: preloadOptions?.preloadingMode
        });
    }, [
        createAnalyticsEvent,
        name,
        preloadOptions?.preloadingMode
    ]);
    const onMouseDown = (0, $cozmU.useCallback)(()=>{
        preloadRef.current = false;
    }, []);
    // Helper to chain child handlers with hover-preloader handlers
    const chain = (...fns)=>(...args)=>{
            fns.forEach((fn)=>{
                if (fn) fn(...args);
            });
        };
    const wrappedChild = /*#__PURE__*/ (0, $cozmU.isValidElement)(children) ? /*#__PURE__*/ (0, $cozmU.cloneElement)(children, {
        onMouseEnter: chain(children.props.onMouseEnter, onMouseEnter),
        onFocus: chain(children.props.onFocus, onMouseEnter),
        onMouseLeave: chain(children.props.onMouseLeave, onMouseLeave),
        onBlur: chain(children.props.onBlur, onMouseLeave),
        onMouseDown: chain(children.props.onMouseDown, onMouseDown)
    }) : children;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("div", {
        "data-vc": `hover-preloader-${name}`,
        "data-testid": "hover-preloader"
    }, wrappedChild);
};
const $b22e252a6b9677fd$export$16d0fec7f7c7ddfa = (props)=>{
    if (!props.preloadUrl) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).Fragment, null, props.children);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($b22e252a6b9677fd$var$TransitionPreloaderImpl, props);
};
const $b22e252a6b9677fd$export$f5ad7b1003f136b2 = {
    onlyJS: {
        preloadingMode: "onlyJS"
    },
    onlyJSAndCriticalData: {
        preloadingMode: "onlyJSAndCriticalData"
    },
    everything: {
        preloadingMode: "everything"
    }
};
module.exports["PreloadingMode"] = $b22e252a6b9677fd$export$3c7387d0e5ed624d;
module.exports["HoverPreloader"] = $b22e252a6b9677fd$export$16d0fec7f7c7ddfa;
module.exports["PreloadingPresets"] = $b22e252a6b9677fd$export$f5ad7b1003f136b2;

});

parcelRegister("3NZlV", function(module, exports) {
module.exports = new URL("CantViewLightMohiti.f5dd9431.svg", import.meta.url).toString();

});

parcelRegister("27iZh", function(module, exports) {
module.exports = new URL("CantViewDarkMohiti.bd8dcb75.svg", import.meta.url).toString();

});

parcelRegister("aeLio", function(module, exports) {

var $dPJCf = parcelRequire("dPJCf");

const $741319b101f491d9$var$useFocusedCommentIdQueryParam = (0, $dPJCf.createSingleQueryParamHook)('focusedCommentId');
const $741319b101f491d9$var$useReplyToCommentIdQueryParam = (0, $dPJCf.createSingleQueryParamHook)('replyToComment');
const $741319b101f491d9$export$f4b5305c973a36dc = ()=>{
    const focusedCommentId = $741319b101f491d9$var$useFocusedCommentIdQueryParam();
    const replyToCommentId = $741319b101f491d9$var$useReplyToCommentIdQueryParam();
    if (focusedCommentId) return 'isFocusedComment';
    else if (replyToCommentId) return 'isReplyToComment';
    return undefined;
};
module.exports["useGetCommentLinkType"] = $741319b101f491d9$export$f4b5305c973a36dc;

});

parcelRegister("c54hr", function(module, exports) {

var $kBr4q = parcelRequire("kBr4q");

var $8s9DV = parcelRequire("8s9DV");

const $367766f6f044c46b$var$initialState = {
    isMenuOpen: false,
    isCloseMenuDisabled: false
};
const $367766f6f044c46b$var$actions = {
    setIsMenuOpen: (isMenuOpen)=>({ setState: setState })=>{
            setState({
                isMenuOpen: isMenuOpen
            });
        },
    setIsCloseMenuDisabled: (isCloseMenuDisabled)=>({ setState: setState })=>{
            setState({
                isCloseMenuDisabled: isCloseMenuDisabled
            });
        }
};
const $367766f6f044c46b$var$Store = (0, $8s9DV.createStore)({
    initialState: $367766f6f044c46b$var$initialState,
    actions: $367766f6f044c46b$var$actions,
    name: 'more-actions-menu-store'
});
const $367766f6f044c46b$export$14d00db016c2b3ef = (0, $kBr4q.createStateHook)($367766f6f044c46b$var$Store);
const $367766f6f044c46b$export$1f1f8c486fa8a1cb = (0, $kBr4q.createActionsHook)($367766f6f044c46b$var$Store);
module.exports["useMoreActionsMenuState"] = $367766f6f044c46b$export$14d00db016c2b3ef;
module.exports["useMoreActionsMenuActions"] = $367766f6f044c46b$export$1f1f8c486fa8a1cb;

});


//# sourceMappingURL=RestrictedPage.513f48e8.js.map
